import { TThunkAction } from '../../types/redux';
import { fetchCreateTripReviewPageData } from '../../services/reviews/fetchCreateTripReviewPageData';
import { getTripId } from '../../selectors/newReview';
import { createReviewDataStart, createReviewDataSuccess, createReviewDataError } from './pageDataActionTypes';
import { EStartReviewErrorCode } from '../../types/newReview';
import { getObjectId } from '../../selectors/objectInfo';

/**
 * Загружает данные для создания отзыва о поездке
 */
export const fetchCreateTripReviewPageDataAction =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();
    const tripId = getTripId(state) || undefined;
    const objectId = getObjectId(state) || undefined;

    dispatch(createReviewDataStart());

    try {
      const { tripInfo, flow, errorCode } = await fetchCreateTripReviewPageData({
        httpApi,
        logger,
        parameters: {
          offerId: objectId,
          tripId,
        },
      });

      if (errorCode) {
        dispatch(createReviewDataError(errorCode));
      } else {
        dispatch(createReviewDataSuccess({ tripInfo, flow }));
      }
    } catch (error) {
      logger.error(error, {
        comment: '[Degradation] Ошибка загрузки данных для формы создания отзыва',
      });
      dispatch(createReviewDataError(EStartReviewErrorCode.Unknown));
    }
  };
